import { Component, signal, input, effect, output } from '@angular/core';
import { CalendarEvent } from 'angular-calendar';
import { updateRideToV2 } from '../../helpers/ride-helper';
import { EventItemComponent } from '../event-item/event-item.component';

@Component({
  selector: 'app-planner-list-view',
  templateUrl: './list-view.component.html',
  styleUrl: './list-view.component.scss',
  imports: [EventItemComponent],
})
export class PlannerListViewComponent {
  events = input<CalendarEvent<any>[]>([]);
  minimized = input(false);
  vehicleGroups = input(false);
  eventClicked = output<CalendarEvent<any>>();

  loading = signal(true);
  processedEvents = signal<CalendarEvent<any>[]>([]);

  constructor() {
    effect(async () => {
      this.loading.set(true);
      const events = await Promise.all(
        this.events().map(async (event) => {
          const ride = event.meta?.ride;
          if (ride) {
            event.meta.ride = ride?.rideVersion === 2 ? ride : updateRideToV2(ride);
          }
          return event;
        }),
      );
      this.processedEvents.set(events);
      this.loading.set(false);
    });
  }

  onEventClick(event: CalendarEvent<any>) {
    this.eventClicked.emit(event);
  }
}
